import React, { Component } from 'react';
import _ from 'lodash';

class OpenQuestion extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: []
		};
		this.handleChange = this.handleChange.bind(this);
	}
	handleValidation(value) {
		const isEmpty = _.isEqual(value, ['']) || _.isEmpty(value);
		return !isEmpty ? true : false;
	}
	handleParentStateCallback(value) {
		const { id, inputName } = this.props.fieldcollection;
		const validation = this.handleValidation(value);
		const obj = {
			id,
			inputName,
			value,
			validation
		};
		this.props.parentStateCallback(obj);
	}
	handleChange(e) {
		const inputValue = [e.target.value];
		this.setState({
			value: inputValue
		});
		this.handleParentStateCallback(inputValue);
	}
	renderInputTxt() {
		const { id } = this.props.fieldcollection;
		return (
			<input
				type="text"
				value={this.state.value}
				id={id}
				onBlur={this.handleChange}
				onChange={this.handleChange}
				className={
					_.includes(this.props.errors, id)
						? 'form-control is-invalid'
						: 'form-control'
				}
			/>
		);
	}
	renderInputNum() {
		const { id } = this.props.fieldcollection;
		return (
			<input
				type="number"
				min={this.props.fieldcollection.config.numMin}
				max={this.props.fieldcollection.config.numMax}
				step="1"
				value={this.state.value}
				id={id}
				onBlur={this.handleChange}
				onChange={this.handleChange}
				className={
					_.includes(this.props.errors, id)
						? 'form-control is-invalid'
						: 'form-control'
				}
			/>
		);
	}
	render() {
		const { id, question } = this.props.fieldcollection;
		return (
			<div className="border rounded px-4 py-3 mb-4">
				<label>
					<h5>{question}</h5>
				</label>
				<div className="form-group">
					{this.props.fieldcollection.config.mostBeNum
						? this.renderInputNum()
						: this.renderInputTxt()}
					{this.props.fieldcollection.config.mostBeNum && (
						<small className="form-text text-muted">
							Digite un número entre {this.props.fieldcollection.config.numMin}{' '}
							y {this.props.fieldcollection.config.numMax}.
						</small>
					)}
					{_.includes(this.props.errors, id) && (
						<div className="invalid-feedback">
							Este campo no puede estar vacio.{' '}
							{this.props.fieldcollection.config.mostBeNum && (
								<strong>
									Y debe ser un número entero entre{' '}
									{this.props.fieldcollection.config.numMin} y{' '}
									{this.props.fieldcollection.config.numMax}.
								</strong>
							)}
						</div>
					)}
				</div>
				<br />
				<div className="d-none">valor: {this.state.value.sort().toString()}</div>
			</div>
		);
	}
}

export default OpenQuestion;



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/FieldCollection/OpenQuestion.js